define(
    "diy/undo-redo/plugins/Layout",
    [
        'diy/undo-redo/plugins/Base',
        'diy/undo-redo/constants',
        'jquery'
    ],
    /**
     *
     * @param {module.undoRedo.plugins.Base} PluginBase
     * @param {module.undoRedo.constants} constants
     * @param {jQuery} $
     * @returns {*}
     */
    function (PluginBase, constants, $) {
        'use strict';
        var Plugin;
        /**
         * @class module.undoRedo.plugins.Layout
         * @template module.undoRedo.plugins.Layout
         * @lends {module.undoRedo.plugins.Layout.prototype}
         * @extends {module.undoRedo.plugins.Base}
         * @constructor
         */
        Plugin = PluginBase.extend({
            onInit: function () {
                var boundEvents = [
                    'diy-editor-templateSwitch-finished'
                ].join(' ');

                $(document).bind(boundEvents, function () {
                    // close the current opened undo session;
                    this.api.onNewEntryServerSide();
                }.bind(this));

                this.markAsReady();
            },
            /**
             *
             * @returns {module.undoRedo.constants.historyEntry.LAYOUT|*}
             */
            getType: function getType() {
                return constants.historyEntry.LAYOUT;
            }
        });

        return Plugin;
    }
);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/undo-redo/plugins/Layout.js
 ** module id = 924
 ** module chunks = 0
 **/